import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypesSavedQueries = {
  list: "list",
  action: "action"
};
export const savedQueriesSlice = createSlice({
  name: "savedQueries",
  initialState: initialState,
  reducers: {
    savedQueriesFetched: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.entities = entities;
      state.error = null;
    },
    savedQueriesAppended: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.error = null;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypesSavedQueries.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypesSavedQueries.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});